export default __webpack_public_path__ + "static/media/leftArrowIcon.d35a9088.svg";